import React from "react";
import { Search, X, Plus, FolderKanban, Users, AlertTriangle } from "lucide-react";
import { ProjectCard } from "./ProjectCard";

const FILTERS = [["all", "Toate"], ["active", "Active"], ["in_progress", "În desfășurare"], ["planning", "Planificare"], ["completed", "Finalizate"]];

function Kpi({ icon: Icon, label, value, tone = "text-ink", testid }) {
  return (
    <div className="bg-white border border-neutral-200 rounded-xl px-3 py-2.5" data-testid={testid}>
      <div className="flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-widest text-ink-muted"><Icon className="h-3 w-3" />{label}</div>
      <div className={`font-display font-bold text-xl tabular-nums ${tone}`}>{value}</div>
    </div>
  );
}

export function ProjectListPanel({ projects, visible, asgByProject, pnlById, load, overByProject, overTotal,
  search, setSearch, filter, setFilter, selectedId, onSelect, canCreate, onNew }) {
  const counts = Object.fromEntries(FILTERS.map(([k]) => [k, k === "all" ? projects.length : projects.filter((p) => p.status === k).length]));
  const people = new Set(Object.values(asgByProject).flat().map((a) => a.employee_id)).size;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-3 gap-2">
        <Kpi icon={FolderKanban} label="Proiecte" value={projects.length} testid="kpi-projects" />
        <Kpi icon={Users} label="Oameni alocați" value={people} testid="kpi-people" />
        <Kpi icon={AlertTriangle} label="Supraalocați" value={overTotal} tone={overTotal ? "text-red-600" : "text-ink"} testid="kpi-overalloc" />
      </div>
      <div className="flex gap-2">
        <div className="flex-1 flex items-center gap-2 h-10 px-3 rounded-lg border border-neutral-200 bg-white focus-within:border-brand">
          <Search className="h-4 w-4 text-neutral-400 shrink-0" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Caută nume, cod, SAGA, client..."
            data-testid="project-search" style={{ boxShadow: "none" }}
            className="flex-1 min-w-0 bg-transparent outline-none border-0 text-sm placeholder:text-neutral-400" />
          {search && <button type="button" data-testid="project-search-clear" onClick={() => setSearch("")} className="text-ink-muted hover:text-ink"><X className="h-4 w-4" /></button>}
        </div>
        {canCreate && (
          <button data-testid="project-new" onClick={onNew} title="Proiect nou"
            className="h-10 px-3 rounded-lg bg-brand text-white text-sm font-medium flex items-center gap-1.5 hover:bg-[#2f5290] transition-colors shrink-0">
            <Plus className="h-4 w-4" /> Nou
          </button>
        )}
      </div>
      <div className="flex gap-1.5 flex-wrap">
        {FILTERS.map(([k, label]) => (
          <button key={k} type="button" data-testid={`status-filter-${k}`} onClick={() => setFilter(k)}
            className={`px-3 py-1 rounded-full text-[12px] font-medium transition-colors ${filter === k ? "bg-ink text-white" : "bg-white border border-neutral-200 text-ink-muted hover:text-ink hover:border-neutral-300"}`}>
            {label} <span className="opacity-60 tabular-nums">{counts[k]}</span>
          </button>
        ))}
      </div>
      <div className="space-y-2" data-testid="assignments-list">
        {visible.length === 0 && <div className="py-12 text-center text-sm text-ink-muted bg-white border border-dashed border-neutral-200 rounded-xl">Niciun proiect nu corespunde.</div>}
        {visible.map((p) => (
          <ProjectCard key={p.id} p={p} rows={asgByProject[p.id] || []} pnl={load ? pnlById[p.id] || null : undefined}
            overCount={overByProject[p.id] || 0} selected={selectedId === p.id} onSelect={() => onSelect(p.id)} />
        ))}
      </div>
    </div>
  );
}
